import { create } from "zustand";

const useDashboardStore = create((set) => ({
  isHomeScreen: false,
  isIconChoosed: false,
  isUS30Choosed: false,
  isCommunityChoosed: false,
  communityIndex: null,
  communities: [],
  traders: [],
  users: [],
  channels: [],
  allChannels: [],
  selectedChannel: null,
  selectedZoomSession: null,
  editCommunityId: null,
  editChannelId: null,
  editLiveSession: null,
  editHomeSectionId: null,
  editStoryId: null,
  showStoriesViewer: false,
  storiesViewerStartIndex: 0,
  viewerStories: [],
  viewedStoryIds: [],
  userJoinedChannels: [],

  setIsHomeScreen: () => {
    set({
      isHomeScreen: true,
      isIconChoosed: false,
      isUS30Choosed: false,
      isCommunityChoosed: false,
      communityIndex: null,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "HomeScreen");
  },

  setIsIconChoosed: () =>
    set({
      isHomeScreen: false,
      isIconChoosed: true,
      isUS30Choosed: false,
      isCommunityChoosed: false,
      communityIndex: null,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    }),

  setIsUS30Choosed: () => {
    set({
      isHomeScreen: false,
      isIconChoosed: false,
      isUS30Choosed: true,
      isCommunityChoosed: false,
      communityIndex: null,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "US30");
  },

  setCommunityIndex: (index) => {
    set({
      isHomeScreen: false,
      isIconChoosed: false,
      isUS30Choosed: false,
      isCommunityChoosed: true,
      communityIndex: index,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("communityIndex", String(index));
  },

  setCommunities: (communities) => set({ communities }),
  setChannels: (channels) => set({ channels }),
  setAllChannels: (channels) => set({ allChannels: channels }),
  setTraders: (traders) => set({ traders }),
  setUsers: (users) => set({ users }),
  setSelectedChannel: (channel) => {
    set({ selectedChannel: channel });
    localStorage.setItem("selectedChannel", JSON.stringify(channel));
  },
  setSelectedZoomSession: (zoom) => set({ selectedZoomSession: zoom }),
  setEditCommunityId: (id) => set({ editCommunityId: id }),
  setEditChannelId: (id) => set({ editChannelId: id }),
  setEditLiveSession: (session) => set({ editLiveSession: session }),
  setEditHomeSectionId: (id) => set({ editHomeSectionId: id }),
  setEditStoryId: (id) => set({ editStoryId: id }),
  setShowStoriesViewer: (show, stories = [], startIndex = 0) =>
    set({ showStoriesViewer: show, viewerStories: stories, storiesViewerStartIndex: startIndex }),
  initViewedStoryIds: (ids) => set({ viewedStoryIds: ids }),
  addViewedStoryId: (id) =>
    set((state) => ({
      viewedStoryIds: state.viewedStoryIds.includes(id)
        ? state.viewedStoryIds
        : [...state.viewedStoryIds, id],
    })),
  setUserJoinedChannels: (channels) => set({ userJoinedChannels: channels }),

  //For Showing the Right Cards:
  isCreateCommunityScreen: false,
  isEditUs30ContentScreen: false,
  isCommunityContentScreen: false,
  isAllCommunityScreen: false,
  isCreateChannelScreen: false,
  isAllChannelScreen: false,
  isChatScreen: false,
  isCreateLiveSessionScreen: false,
  isAllLiveSessionScreen: false,
  isAllHomeSectionScreen: false,
  isCreateHomeSectionScreen: false,
  isZoomMeetingScreen: false,
  isUpcomingLiveSessionScreen: false,
  isUsersScreen: false,
  isMyProfileScreen: false,
  isMyMembershipScreen: false,
  isEditWeeklyLinksContentScreen: false,
  isEditReplaySessionsContentScreen: false,
  isWeeklyLinksScreen: false,
  isReplaySessionsScreen: false,
  isWeeklyLinksScreen: false,
  isReplaySessionsScreen: false,
  isAllStoriesScreen: false,
  isCreateStoryScreen: false,

  setIsCreateCommunityScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: true,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "CreateCommunityScreen");
  },

  setIsEditUs30ContentScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: true,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "EditUs30ContentScreen");
  },

  setIsCommunityContentScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: true,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "CommunityContentScreen");
  },

  setIsAllCommunityScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: true,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "AllCommunityScreen");
  },

  setIsCreateChannelScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: true,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "CreateChannelScreen");
  },

  setIsAllChannelScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: true,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "AllChannelScreen");
  },

  setIsChatScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: true,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "ChatScreen");
  },

  setIsCreateLiveSessionScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: true,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "CreateLiveSessionScreen");
  },

  setIsAllLiveSessionScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: true,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "AllLiveSessionScreen");
  },

  setIsAllHomeSectionScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: true,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "AllHomeSectionScreen");
  },

  setIsCreateHomeSectionScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: true,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "CreateHomeSectionScreen");
  },

  setIsAllStoriesScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: true,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "AllStoriesScreen");
  },

  setIsCreateStoryScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: true,
    });
    localStorage.setItem("lastScreen", "CreateStoryScreen");
  },

  setIsZoomMeetingScreen: () =>
    set({
      isHomeScreen: false,
      isUS30Choosed: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: true,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    }),

  setIsUpcomingLiveSessionScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: true,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "UpcomingLiveSessionScreen");
  },

  setIsUsersScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: true,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "UsersScreen");
  },

  setIsMyProfileScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: true,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "MyProfile");
  },

  setIsMyMembershipScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: true,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "MySubscription");
  },

  // Weekly Links Content Screen
  setIsEditWeeklyLinksContentScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: true,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "EditWeeklyLinksContentScreen");
  },

  //Replay Sessions Content Screen
  setIsEditReplaySessionsContentScreen: () => {
    set({
      isHomeScreen: false,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: true,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    });
    localStorage.setItem("lastScreen", "EditReplaySessionsContentScreen");
  },

  // Weekly Links Screen (User-facing)
  setIsWeeklyLinksScreen: () => {
    set({
      isHomeScreen: false,
      isIconChoosed: false,
      isUS30Choosed: false,
      isCommunityChoosed: true,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: true,
      isReplaySessionsScreen: false,
    });
    localStorage.setItem("lastScreen", "WeeklyLinksScreen");
  },

  // Replay Sessions Screen (User-facing)
  setIsReplaySessionsScreen: () => {
    set({
      isHomeScreen: false,
      isIconChoosed: false,
      isUS30Choosed: false,
      isCommunityChoosed: true,
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: true,
    });
    localStorage.setItem("lastScreen", "ReplaySessionsScreen");
  },

  resetDashboard: () =>
    set({
      isHomeScreen: false,
      isIconChoosed: false,
      isUS30Choosed: false,
      isCommunityChoosed: false,
      communityIndex: null,
      communities: [],
      traders: [],
      users: [],
      channels: [],
      allChannels: [],
      selectedChannel: null,
      selectedZoomSession: null,
      editCommunityId: null,
      editChannelId: null,
      editLiveSession: null,
      editHomeSectionId: null,
      editStoryId: null,
      showStoriesViewer: false,
      storiesViewerStartIndex: 0,
      viewerStories: [],
      viewedStoryIds: [],
      userJoinedChannels: [],
      isCreateCommunityScreen: false,
      isEditUs30ContentScreen: false,
      isCommunityContentScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
      isEditWeeklyLinksContentScreen: false,
      isEditReplaySessionsContentScreen: false,
      isWeeklyLinksScreen: false,
      isReplaySessionsScreen: false,
      isAllStoriesScreen: false,
      isCreateStoryScreen: false,
    }),
}));

export default useDashboardStore;
